<template>
    <section class="Poker space-l" loading="lazy">
         <div class="container-fluid">
            <div class="row  no-gutters">
               <div class="col-md-4 col-12">
                  <h1 class="live-patti-header">
                     32 Card Casino
                  </h1>
                  <div class="teen-patti-img">
                     <img loading="lazy" src="@/assets/images/32-card-casino.webp" alt="32-card-casino">
                  </div>
               </div>
               <div class="col-md-8 col-12">
                  <div class="rules">
                     <h2 class="live-patti-header">
                        Objective
                     </h2>
                     <div class="v-rules">
                        The objective of 32 Card is to predict the winning player of the game round. 32 Card casino is played with a deck of 32 card which does not include A,2,3,4,5 ranked cards.
                        To win, you need to predict if sum of the base value of player
                        and cards dealt to player will be higher, lower of all of them. You can either back or lay any player. On Draw between one or more players, 
                        market will be reopned for next cards.
                     </div>
                     <h2 class="live-patti-header">
                        Betting flow:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list">
                           <li>
                              If a game round is in progress when you enter the table, please wait for the next one, and then, place your bets.
                           </li>
                           <li>
                              To place a bet, choose a chip and place it on the betting position.
                           </li>
                           <li>
                              You can place several chips on different betting positions simultaneously.
                           </li>
                           <li>
                              The timer in the game window shows how much time you have left to place your bets.
                           </li>
                           <li>
                              After the No More Bets signal, the game round begins.
                           </li>
                           <li>
                              Winnings are paid for the winning bets at the end of each game round.
                           </li>
                           <li>
                              To play a game round, place your bets again or use the Rebet button.
                           </li>
                           <li>
                              To skip a turn, simply do not place any bets on the table. Two Pair
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Game flow:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list">
                           <li>
                              When the first game round starts, No cards are dealt but market is opened for initial Betting.
                           </li>
                           <li>
                              After the market is suspended, each player gets one card per head.
                           </li>
                           <li>
                              If you lost the round, the bet amount is taken off the table. If you won the round, the winnings are added to your Balance.
                           </li>
                           <li>
                              If the there is Tie between any two players, Market is reopened for betting to declare the winner. This will continue till the one winner is declared.
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Limit ranges:
                     </h2>
                     <div class="v-rules">
                        If it is possible to bet an amount that could potentially 
                        result in a win larger than the maximum payout limit, then the bet is automatically adjusted to the maximum possible amount for this position.
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
</template>